import React, { useEffect } from 'react';
import { ReviewCard } from '../components/ReviewCard';
import { CTABand } from '../components/CTABand';
export function Reviews() {
  useEffect(() => {
    document.title = 'Reviews | Storm Taekwondo';
  }, []);
  const reviews = [{
    quote: 'My son has been going here for 6 months and his confidence has skyrocketed. The coaches are amazing with the kids.',
    name: 'Sarah M.',
    label: 'Parent Review'
  }, {
    quote: "Great family atmosphere. We started in the family class and it's been the best decision we've made for our health.",
    name: 'David R.',
    label: 'Parent Review'
  }, {
    quote: 'The discipline and focus my daughter has learned here translates directly to her schoolwork. Highly recommend Storm!',
    name: 'Jennifer L.',
    label: 'Parent Review'
  }, {
    quote: 'As an adult beginner, I was nervous to start. The coaches made me feel welcome immediately. Great workout and great people.',
    name: 'Michael T.',
    label: 'Student Review'
  }, {
    quote: 'Mini Troopers is fantastic! My 4-year-old listens better at home and loves going to class every week.',
    name: 'Amanda K.',
    label: 'Parent Review'
  }, {
    quote: 'The competition team training is elite. Coach Megan really knows how to pull the best out of her athletes.',
    name: 'James P.',
    label: 'Student Review'
  }, {
    quote: 'We drive from Novi just to come here. The facility is clean, the instruction is top-notch, and the community is wonderful.',
    name: 'Rachel B.',
    label: 'Parent Review'
  }, {
    quote: "I've lost weight, gained confidence, and learned real self-defense skills. Storm Taekwondo changed my life.",
    name: 'Chris W.',
    label: 'Student Review'
  }, {
    quote: 'They strike the perfect balance between fun and discipline. My kids respect the coaches and always leave sweating and smiling.',
    name: 'Tom H.',
    label: 'Parent Review'
  }];
  return <div className="flex flex-col bg-off-white" data-id="element-675">
      {/* Hero */}
      <section className="bg-ink py-20 text-center px-4" data-id="element-676">
        <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-677">
          What Storm Families Are Saying
        </h1>
        <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-678">
          Don't just take our word for it. Hear from the parents and students
          who train with us every week.
        </p>
      </section>

      {/* Reviews Grid */}
      <section className="py-24" data-id="element-679">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-680">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-681">
            {reviews.map((review, idx) => <ReviewCard key={idx} quote={review.quote} name={review.name} label={review.label} data-id="element-682" />)}
          </div>
        </div>
      </section>

      <CTABand headline="Ready to Write Your Own Success Story?" copy="Join the hundreds of families who have found confidence, fitness, and community at Storm Taekwondo." data-id="element-683" />
    </div>;
}